module.exports = __webpack_public_path__ + "img/plan3_book11.a6849faa.png";